var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle127(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "140.35483383406594 460.991276320405 13.99850890265651 14.150801657755778",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M150.34,468.44c-.14,1.7-1.58,2.88-3.29,2.68-1.64-.19-2.89-1.75-2.67-3.36.22-1.66,1.79-2.94,3.34-2.75,1.64.21,2.77,1.68,2.62,3.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle127);
export default __webpack_public_path__ + "static/media/twinkle-1-27.8744faf2041f0e8017c3035df8b57ea3.svg";
export { ForwardRef as ReactComponent };